import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Aceita reagendar esta sessão?", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, " Paciente solicitou um novo horário para esta sessão, você aceita alterar a data da sessão? ", -1)
const _hoisted_5 = { class: "d-flex align-items-center py-4 border-bottom justify-content-between" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, "Novo dia", -1)
const _hoisted_7 = { class: "text-subtitle mb-0" }
const _hoisted_8 = { class: "d-flex align-items-center py-4 justify-content-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, "Novo horário", -1)
const _hoisted_10 = { class: "text-subtitle mb-0" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "d-flex align-items-center mb-3" }
const _hoisted_13 = { class: "text-subtitle mb-0 ms-2" }
const _hoisted_14 = { class: "text-paragraph mb-0" }

import { useUpdateRescheduleRequest } from "@/composables/useAppointments";
import type { RescheduleRequestData } from "@phurshell/psiapp-frontend-core/domain";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RescheduleRequest',
  props: {
    request: {}
  },
  setup(__props: any) {

const props = __props;

const rejectingReschedule = ref(false);
const acceptingReschedule = ref(false);

const { mutateAsync: updateRescheduleRequest } = useUpdateRescheduleRequest();

async function handleRescheduleRequest(status: string) {
  try {
    acceptingReschedule.value = status === "acecpted";
    rejectingReschedule.value = status === "rejected";

    await updateRescheduleRequest({ id: props.request.id, status });
  } catch (error) {
    console.log(
      "ERRO NO HANDLE RESCHEDULE REQUEST NO APPOINTMENT DETAIL SCREEN",
      error,
    );
  } finally {
    rejectingReschedule.value = false;
    acceptingReschedule.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TimezoneAlert = _resolveComponent("TimezoneAlert")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.request.pendingByMe)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.request.formattedDate), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, [
              _createVNode(_component_TimezoneAlert, { icon: "" }),
              _createTextVNode(" " + _toDisplayString(_ctx.request.formattedTime), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              label: "Rejeitar",
              outline: "",
              loading: rejectingReschedule.value,
              fullWidth: "",
              class: "me-2",
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (handleRescheduleRequest('rejected')))
            }, null, 8, ["loading"]),
            _createVNode(_component_Button, {
              label: "Aceitar",
              loading: acceptingReschedule.value,
              fullWidth: "",
              class: "ms-2",
              onOnClick: _cache[1] || (_cache[1] = ($event: any) => (handleRescheduleRequest('acecpted')))
            }, null, 8, ["loading"])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "alert",
        style: _normalizeStyle({ backgroundColor: _ctx.request.bgColor, color: _ctx.request.color })
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("i", {
            class: _normalizeClass(`fa-solid fa-${_ctx.request.icon} me-2`)
          }, null, 2),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.request.title), 1)
        ]),
        _createElementVNode("p", _hoisted_14, " O reagendamento desta sessão " + _toDisplayString(_ctx.request.descriptionStatus) + ". O novo horário proposto é " + _toDisplayString(_ctx.request.descriptionDate) + ", " + _toDisplayString(_ctx.request.descriptionTime) + ". ", 1)
      ], 4))
}
}

})